import type WhiteboardController from '../controllers/WhiteboardController';
import { makeTestId } from '../utils/tools';
import Stylus from './Stylus';
import ComponentDrawingBrush from './ComponentDrawingBrush';
import styles from '../styles.module.css';
import { svgToIcon } from '../utils/svg';
import stackSvg from '../assets/icons/componentStack.svg';
import swimlaneSvg from '../assets/icons/componentSwimlane.svg';
import boardSvg from '../assets/icons/componentBoard.svg';
import { capitalize } from 'lodash';
import { labeledMenuComponent } from '../utils/stylus';
import { type ComponentNames } from '../objects/components';

// The base class for drawing instruments that create or manipulate objects
// on the canvas.
class StylusComponent extends Stylus {
  stylusType?: string;
  controller: WhiteboardController;
  componentName: ComponentNames;

  constructor({
    controller,
    componentName,
  }: {
    controller: WhiteboardController;
    componentName: ComponentNames;
  }) {
    super({ controller });
    this.controller = controller;
    this.componentName = componentName;
  }

  activate() {
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = new ComponentDrawingBrush(
      this.controller.canvas,
      this,
      this.componentName
    );
  }

  stylusId() {
    return `component-${this.componentName}`;
  }

  renderIcon() {
    switch (this.componentName) {
      case 'stack':
        return svgToIcon(stackSvg);
      case 'swimlane':
        return svgToIcon(swimlaneSvg);
      case 'board':
        return svgToIcon(boardSvg);
      default: {
        const _exhaustivenessCheck: never = this.componentName;
        return _exhaustivenessCheck;
      }
    }
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  description() {
    return capitalize(this.componentName);
  }

  testid() {
    return `Stylus-${makeTestId(this.description())}`;
  }
}

export default StylusComponent;
